export const appMixin = {
  methods: {
    async getPublicIpAddress() {
      // Best-effort metadata only — never let a slow/unreachable third party
      // block the caller (e.g. signup). Abort after 3s so fetch can't hang
      // indefinitely (a stalled connection never rejects on its own).
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);
      try {
        let publicIpResponse = await fetch('https://api.seeip.org/jsonip?', {
          signal: controller.signal,
        });
        if (publicIpResponse) {
          publicIpResponse = await publicIpResponse.text();
          const {ip} = JSON.parse(publicIpResponse);
          return ip;
        }
      } catch (e) {
        console.warn(e);
        return null;
      } finally {
        clearTimeout(timer);
      }
      return null;
    },
  },
};

export default {appMixin};
